import styled from './styled-components';
/**
 * just type to make styled-component work with Mui dynamic component type,
 *
 * you need custom Map type like below, define the defaultComponent type and provide that static Props
  *
 *
 * @example
 *
 * ```ts
 *  interface RcPaginationItemTypeMap<D extends React.ElementType = 'div'> {
      props: RcPaginationItemProps;
      defaultComponent: D;
    }
   ```
 */
export var overridableStyled = styled;
